import { FC } from "react";

interface RolesPageIconSVGProps {
    className?: string;
}

const RolesPageIconSVG: FC<RolesPageIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width={24}
            height={24}
            fill="none"
        >
            {/* Коло як основа ролі */}
            <circle cx="12" cy="12" r="10" />
            {/* Ключ як символ ролі */}
            <rect x="10" y="8" width="4" height="2" rx="1" />
            <path d="M12 10v4" />
            <circle cx="12" cy="16" r="1" />
        </svg>
    );
};

export default RolesPageIconSVG;
